export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  {
    url: "/tab/118/page",
    name: "시스템 계약 현황",
    icon: "",
    activeCode: "",
    groupName: ["118"],
  },
  {
    url: "/",
    name: "신규 사업장 등록 요청",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/300",
        name: "직영작업장",
        icon: "w-line",
        activeCode: "",
        groupName: ["300"],
      },
    ],
  },
  {
    url: "/",
    name: "사업장 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace-insider",
        name: "직영작업장",
        icon: "w-line",
        activeCode: "field-workplace-insider",
      },
    ],
  },
  {
    url: "/",
    name: "안전보건조직체계",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/282",
        name: "안전보건관리책임자 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["282"],
      },
      {
        url: "/tab/297",
        name: "관리감독자 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["297"],
      },
      {
        url: "/tab/126",
        name: "안전보건 조직 체계도",
        icon: "w-line",
        activeCode: "",
        groupName: ["126"],
      },
      // {
      //   url: '/company/info',
      //   name: '소속부서 및 담당업체 정보',
      //   icon: 'w-line',
      //   activeCode: 'company-info',
      // },
      // {
      //   url: '/tab/141',
      //   name: '안전보건 관련 인력',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['141'],
      // },
      // {
      //   url: '/tab/136',
      //   name: '안전보건 점검 인력',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['136'],
      // },
      {
        url: "/tab/358",
        name: "종사자 정보",
        icon: "w-line",
        activeCode: "",
        groupName: ["358"],
      },
      // {
      //   url: '/tab/138',
      //   name: '비상 연락/지원 체계도',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['138'],
      // },
      {
        url: "/tab/304",
        name: "유관기관 비상연락망",
        icon: "w-line",
        activeCode: "",
        groupName: ["304"],
      },
      // {
      //   url: '/tab/119',
      //   name: '안전보건관리 책임자 지정 외',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['119', '120', '121', '122', '123', '125'],
      // },
    ],
  },
  {
    url: "/",
    name: "안전보건관리체계",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/468",
        name: "중대산업재해 종합계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["468"],
      },
      {
        url: "/tab/469",
        name: "부서별 안전보건계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["469"],
      },
      {
        url: "/tab/137",
        name: "안전보건 점검 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["137"],
      },
      {
        url: "/tab/101",
        name: "안전보건 경영방침",
        icon: "w-line",
        groupName: ["101"],
      },
      // {
      //   url: '/tab/109',
      //   name: '사업장 안전·보건 경영방침',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['109'],
      // },
      {
        url: "/tab/134",
        name: "반기별 보고",
        icon: "w-line",
        activeCode: "",
        groupName: ["134"],
      },

      {
        url: "/tab/286",
        name: "[공통]안전보건(총괄)관리책임자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["286"],
      },
      {
        url: "/tab/287",
        name: "[공통]관리감독자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["287"],
      },
      // {
      //   url: "/tab/130",
      //   name: "수급업체 수행평가",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["130"],
      // },
      {
        url: "/tab/129",
        name: "종사자 참여 평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["129"],
      },

      {
        url: "/tab/131",
        name: "수시 점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["131"],
      },
      {
        url: "/tab/467/page",
        name: "안전보건 확보 의무",
        icon: "w-line",
        activeCode: "",
        groupName: ["467"],
      },
      // {
      //   url: "/tab/153",
      //   name: "노사협의체",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["153"],
      // },
    ],
  },
  {
    url: "/",
    name: "의무 이행사항 점검(반기1회)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/463",
        name: "안전보건관리책임자",
        icon: "w-line",
        activeCode: "",
        groupName: ["463"],
      },
      {
        url: "/tab/464",
        name: "관리감독자",
        icon: "w-line",
        activeCode: "",
        groupName: ["464", "939"],
      },
    ]
  },
  {
    url: "/",
    name: "산업안전보건위원회",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/152",
        name: "산업안전보건위원 현황",
        icon: "w-line",
        activeCode: "",
        groupName: ["152"],
      },
      // 개최 현황
    ]
  },
  {
    url: "/",
    name: "건강진단 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/318",
        name: "특수건강진단",
        icon: "w-line",
        activeCode: "",
        groupName: ["318"],
      },
    ],
  },
  {
    url: "/",
    name: "안전보건 예산",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/_106/page",
        name: "부서별 안전보건 예산(A형)",
        icon: "w-line",
        activeCode: "",
        groupName: ["106/page"],
      },
      {
        url: "/tab/106",
        name: "안전보건 예산(A형)",
        icon: "w-line",
        activeCode: "",
        groupName: ["106"],
      },
    ],
  },
  {
    url: "/",
    name: "교육 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/107",
        name: "안전·보건 교육",
        icon: "w-line",
        activeCode: "",
        groupName: ["107"],
      },
      {
        url: "/tab/132/page",
        name: "교육 모니터링",
        icon: "w-line",
        activeCode: "",
        groupName: ["132"],
      },
    ],
  },
  {
    url: "/",
    name: "유해·위험요인 관리",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/539",
        name: "보호구 지급 및 관리",
        icon: "w-line",
        activeCode: "",
        groupName: ["539"],
      },
      {
        url: "/tab/540",
        name: "위험기계기구 설비 관리",
        icon: "w-line",
        activeCode: "",
        groupName: ["540"],
      },
      {
        url: "/tab/541",
        name: "안전검사",
        icon: "w-line",
        activeCode: "",
        groupName: ["541"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/288",
        name: "[공통]현장순회점검일지(현업근로자 위험성평가)",
        icon: "w-line",
        activeCode: "",
        groupName: ["288"],
      },
      {
        url: "/tab/161",
        name: "정기 위험성평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["161"],
      },
      {
        url: "/tab/162",
        name: "수시 위험성평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["162"],
      },
      {
        url: "/tab/151",
        name: "위험성평가협의회",
        icon: "w-line",
        activeCode: "",
        groupName: ["151"],
      },
    ],
  },
  {
    url: "/",
    name: "안전작업계획(허가)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/246",
        name: "안전작업계획서(고위험작업)",
        icon: "w-line",
        activeCode: "",
        groupName: ["246"],
      },
      {
        url: "/tab/257",
        name: "작업허가서",
        icon: "w-line",
        activeCode: "",
        groupName: ["257"],
      },
    ],
  },
  {
    url: "/",
    name: "안전보건 점검",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/377",
        name: "TBM(작업 전 안전점검회의)",
        icon: "w-line",
        activeCode: "",
        groupName: ["377"],
      },
      {
        url: '/tab/378',
        name: 'TBM 실행 체크리스트',
        icon: 'w-line',
        activeCode: '',
        groupName: ['378'],
      },
      {
        url: "/tab/163",
        name: "일일안전보건점검일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["163"],
      },
      {
        url: "/tab/100",
        name: "작업장 합동점검",
        icon: "w-line",
        activeCode: "",
        groupName: ["100"],
      },
      {
        url: "/tab/289",
        name: "[공통]안전보건 순회점검",
        icon: "w-line",
        activeCode: "",
        groupName: ["289"],
      },
      {
        url: "/tab/291",
        name: "[공통]안전 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["291"],
      },
      {
        url: "/tab/290",
        name: "[공통]보건 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["290"],
      },
      {
        url: "/tab/292",
        name: "[공통]근골격계 증상조사표(근로자)",
        icon: "w-line",
        activeCode: "",
        groupName: ["292"],
      },
      {
        url: "/tab/293",
        name: "[공통]근골격계부담작업 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["293"],
      },
      {
        url: "/tab/296",
        name: "[공통]동청사 안전점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["296"],
      },
      // {
      //   url: '/tab/166',
      //   name: '냉온수기 및 보일러 설비',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['166'],
      // },
      // {
      //   url: '/tab/110',
      //   name: '도로 보수',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['110'],
      // },
      // {
      //   url: "/tab/168",
      //   name: "시설물 관리(공통)",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["168"],
      // },
      // {
      //   url: '/tab/164',
      //   name: '요양보호사',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['164'],
      // },
      // {
      //   url: '/tab/165',
      //   name: '종사자 및 주차시설',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['165'],
      // },
      // {
      //   url: '/tab/167',
      //   name: '행사자 동선 및 관계자',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['167'],
      // },
      // {
      //   url: '/',
      //   name: '외 점검표...',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: [''],
      // },
      {
        url: '/tab/447',
        name: 'MSDS(물질안전보건자료)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['447'],
      },
      {
        url: '/tab/466',
        name: '작업환경측정',
        icon: 'w-line',
        activeCode: '',
        groupName: ['466'],
      },
      {
        url: '/tab/888',
        name: 'TBM 일지',
        icon: 'w-line',
        activeCode: '',
        groupName: ['888'],
      },
    ],
  },
  {
    url: "/",
    name: "재해발생 대비 대책",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/116/page",
        name: "(재해발생) 산업재해 발생 시 보고 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["116"],
      },
      {
        url: "/tab/238/page",
        name: "(재해발생) 비상조치 및 처리 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["238"],
      },
      {
        url: "/tab/239",
        name: "비상대피 훈련·교육·자체평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["239", "240", "241"],
      },
      {
        url: "/tab/242",
        name: "비상조치계획 수립",
        icon: "w-line",
        activeCode: "",
        groupName: ["242"],
      },
    ],
  },
  {
    url: "/",
    name: "재해발생보고",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/117",
        name: "산업재해조사표",
        icon: "w-line",
        activeCode: "",
        groupName: ["117"],
      },
      {
        url: "/tab/346",
        name: "중대재해 발생 보고",
        icon: "w-line",
        activeCode: "",
        groupName: ["346"],
      },
      {
        url: "/tab/245",
        name: "재발방지계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["245"],
      },
      {
        url: '/tab/307',
        name: '안전사고 발생 보고서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['307'],
      },
      {
        url: '/tab/308',
        name: '재발방지 조치 보고서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['308'],
      },
    ],
  },
  {
    url: "/",
    name: "자료실",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/filelibrary/341",
        name: "자료실",
        activeCode: "filelibrary-341",
        icon: "w-line",
      },
    ],
  },
  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "중대재해 발생 사례 공유",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ['16'],
      },
      {
        url: "/community/healthinfo",
        name: "안전보건 주요 일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ['18'],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ['19'],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ['17'],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ['90'],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ['91'],
      },
      {
        url: "/",
        name: "결재관리",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/approval-request",
            name: "결재요청함",
            slug: "",
            icon: "w-line",
            groupName: ['93'],
          },
          {
            url: "/approval-await",
            name: "결재대기함",
            slug: "",
            icon: "w-line",
            groupName: ['94'],
          },
          {
            url: "/approval-process",
            name: "결재진행함",
            slug: "",
            icon: "w-line",
            groupName: ['95'],
          },
          {
            url: "/approval-complete",
            name: "완료문서함",
            slug: "",
            icon: "w-line",
            groupName: ['96'],
          },
          {
            url: "/approval-reject",
            name: "반려문서함",
            slug: "",
            icon: "w-line",
            groupName: ['97'],
          },
          {
            url: "/approval-reference",
            name: "참조/회람문서함",
            slug: "",
            icon: "w-line",
            groupName: ['98'],
          },
        ],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ['92'],
          },
        ],
      },
    ],
  },
];
